/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type WordOrderExerciseSummary_exercise = {
    readonly content: {
        readonly correctAnswers: ReadonlyArray<string>;
        readonly scrambledParts: ReadonlyArray<string>;
    };
    readonly " $refType": "WordOrderExerciseSummary_exercise";
};
export type WordOrderExerciseSummary_exercise$data = WordOrderExerciseSummary_exercise;
export type WordOrderExerciseSummary_exercise$key = {
    readonly " $data"?: WordOrderExerciseSummary_exercise$data;
    readonly " $fragmentRefs": FragmentRefs<"WordOrderExerciseSummary_exercise">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "WordOrderExerciseSummary_exercise",
  "type": "WordOrderExercise",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "content",
      "storageKey": null,
      "args": null,
      "concreteType": "WordOrderExerciseContent",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "correctAnswers",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "scrambledParts",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '60889386348e6c2f43b422356e5da544';
export default node;
